import { useEffect } from "react";
import { makeAjax, url, respStatus, showMessage } from "../../helpers/global_helper";

const TextDataScript = ({ payload, setPageContent }) => {
    const fetchInformation = async () => {
        const payloadData = { code: payload };
        try {
            const response = await makeAjax(url.USER_API.getTextInfo, payloadData, url.USER_MS_EXT);
            if (response.status !== respStatus["SUCCESS"]) {
                showMessage(response);
                return null;
            }
            return response.data?.value || null;
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    useEffect(() => {
        const loadInformation = async () => {
            const data = await fetchInformation();
            if (data) {
                if (payload === 'about_us') {
                    setPageContent(data);
                } else {
                    const element = document.getElementById("title");
                    if (element) {
                        if (payload == 'google_script') {
                            const scriptId = 'google-ga-script';
                            document.querySelectorAll(`script[data-id="${scriptId}"]`).forEach(s => s.remove());
                            const parser = document.createElement('template');
                            parser.innerHTML = data.trim() + '</script>';
                            const scripts = parser.content.querySelectorAll('script');
                            scripts.forEach(tag => {
                                const script = document.createElement('script');
                                script.setAttribute('data-id', scriptId);
                                if (tag.src) {
                                    script.src = tag.src;
                                    script.async = tag.async;
                                } else {
                                    script.textContent = tag.textContent;
                                }
                                document.head.appendChild(script);
                            });
                        } else {
                            element.insertAdjacentHTML('beforebegin', data);
                        }
                    }
                }
            }
        };
        loadInformation();
    }, [payload, setPageContent]);

    return null;
}

export { TextDataScript };
